var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"greeting-card"},[_c('div',{staticClass:"greeting-icon"},[_c('i',{class:_vm.greetingIcon})]),_c('div',{staticClass:"greeting-content"},[_c('div',{staticClass:"greeting-text"},[_vm._v(_vm._s(_vm.greetingText)+"，"+_vm._s(_vm.displayName))]),_c('div',{staticClass:"greeting-desc"},[_vm._v(_vm._s(_vm.greetingDesc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }